  <!-- 车辆成本表 -->
 <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore">
      <template slot="time1">
        <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
      </template>
    </input-plug>

    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" ref="mytable" @selectChange="handleSelectionChange" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true">
        <template slot="time1">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
<script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "车辆损益表", //导出时默认文件名
        apiName: "/admin/v3/tms/report/getCarProfitList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "导出",
          method: "exportData",
          permissVal: "aaaaa",
        },
        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "打印",
          method: "printData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "select",
          label: "车辆类型",
          field: "carCategoryConfDictId",
          setLabel: "val",
          setValue: "confDictId",
          placeholder: "请选择",
          selectOptions: [],
        },
        {
          type: "input",
          label: "车牌号",
          field: "carNumber",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "车型",
          field: "carTypeConfDictId",
          setLabel: "val",
          setValue: "confDictId",
          placeholder: "请选择",
          selectOptions: [],
        },
        {
          type: "select",
          label: "使用部门",
          field: "useDeptId",
          setLabel: "departmentName",
          setValue: "deptId",
          placeholder: "请选择",
          selectOptions: [],
        },
      ],

      queryData: {
        carCategoryConfDictId: null,
        carNumber: null,
        carTypeConfDictId: null,
        useDeptId: null,
      },

      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "年月",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "开始时间",
          field: "startBusinessDate",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计 default：false
          isSort: true, //表格设置里面是否可以排序 default：false
        },
        {
          name: "结束时间",
          field: "endBusinessDate",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "车辆类型",
          field: "carCategory",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "车型",
          field: "carType",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "车牌号",
          field: "carNumber",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "车辆使用部门",
          field: "useDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "里程数",
          field: "mileage",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        // {
        //   name: "油费",
        //   field: "aaa",
        //   width: "120",
        //   sort: 18,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: false,
        // },
        // {
        //   name: "路桥费",
        //   field: "aaa",
        //   width: "120",
        //   sort: 19,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: false,
        // },
        // {
        //   name: "停车费",
        //   field: "aaa",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: false,
        // },
        // {
        //   name: "维修保养",
        //   field: "aaa",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: false,
        // },
        // {
        //   name: "保险年审",
        //   field: "aaa",
        //   width: "120",
        //   sort: 2,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: false,
        // },
        // {
        //   name: "折旧",
        //   field: "aaa",
        //   width: "120",
        //   sort: 2,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: false,
        // },

        // {
        //   name: "人工",
        //   field: "aaa",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: false,
        // },
        // {
        //   name: "其他",
        //   field: "aaa",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: false,
        // },
        {
          name: "发车单应收",
          field: "financeInAmount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "总成本",
          field: "totalCost",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "车辆收入",
          field: "allocationCost",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "单位成本/公里",
          field: "unitMileageCost",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "单位变动成本/公里",
          field: "unitMileageChangeCost",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "月发车天数",
          field: "startCarDay",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "出车率",
          field: "startCarRate",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "平均单趟载重率",
          field: "avgUnitDispatchWeightRate",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "平均标准满载率",
          field: "avgUnitDispatchStandardWeightRate",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
      ],
      pageGroupName: "VehiclePL",
      sortName: "车辆损益表", //  排序名
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.getConfDictValDownList("car_category");
    this.getConfDictValDownList("car_type");
    this.GetDeptList();
    this.SteExpandKey();
  },
  methods: {
    // 获取车辆成本表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.queryData.startBusinessDate = this.startTime_a
        ? this.startTime_a + " 00:00:00"
        : "";
      this.queryData.endBusinessDate = this.endTime_a
        ? this.endTime_a + " 23:59:59"
        : "";
      this.$API.CarProfitList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          let tableDataArr = res.data.result?.data || [];
          for (let t in tableDataArr) {
            tableDataArr[t] = {
              ...tableDataArr[t],
              ...tableDataArr[t].expandVals,
            };
          }
          this.tableConfig.tableData = tableDataArr;
          this.className = res.data.result.className || "";
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---车辆成本表`);
        }
      });
    },
    // 设置动态表头
    SteExpandKey() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.queryData.startBusinessDate = this.startTime_a
        ? this.startTime_a + " 00:00:00"
        : "";
      this.queryData.endBusinessDate = this.endTime_a
        ? this.endTime_a + " 23:59:59"
        : "";
      this.$API.CarProfitList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          let ExpandKeyArr = res.data.result?.expandKey || [];
          let tableDataArr = res.data.result?.data || [];
          for (let t in tableDataArr) {
            tableDataArr[t] = {
              ...tableDataArr[t],
              ...tableDataArr[t].expandVals,
            };
          }
          for (let r in ExpandKeyArr) {
            this.tabelHeadeTitle.splice(7, 0, {
              name: ExpandKeyArr[r].fieldKeyShow,
              field: ExpandKeyArr[r].fieldKey,
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: false,
            });
          }
          this.className = res.data.result.className || "";
          this.pageCount = res.data.result.pageCount || 0;
          this.tableConfig.tableData = tableDataArr;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---车辆成本表`);
        }
      });
    },
    //  获取车辆类型
    getConfDictValDownList(PARAM) {
      this.$API.wtl_getConfDictValDownList({ dictType: PARAM }).then((res) => {
        if (res.data.status === "success") {
          if (PARAM === "car_category") {
            this.baseConfig[1].selectOptions = res.data.result || [];
          }
          if (PARAM === "car_type") {
            this.baseConfig[3].selectOptions = res.data.result || [];
          }
        } else {
          console.log(res.data.message);
        }
      });
    },

    // 获取车辆使用部门
    GetDeptList() {
      this.$API.wtl_getDeptList().then((res) => {
        if (res.data.status === "success") {
          this.baseConfig[4].selectOptions = res.data.result?.data || [];
        } else {
          console.log(res.data.message);
        }
      });
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },
    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 导出
    exportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
    // 表格设置
    SetTable() {},
    // 打印
    printData() {},
  },
};
</script>
        <style scoped lang="less">
</style>
                          